import { css } from "styled-components";
import { MixinIcon, MixinIconReversable } from "../common";
export const leagueClientStyle = (chroma) => css `
  &.icon-link {
    ${MixinIconReversable}
    display: inline-block;
    height: 12px;
    width: 12px;
    filter: drop-shadow(0 0 0.7px black) drop-shadow(0 0 1px black) opacity(0.8);

    ::after {
      content: "";
      position: absolute;
      inset: 0;
      ${MixinIcon({ icon: chroma.icons.link, color: chroma.palette.gold4 })};
    }
  }
`;
//# sourceMappingURL=index.js.map